import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'app-global-loading',
    template: `
    <div class="global-overlay" *ngIf="loading()">
      <div class="panel">
        <nz-spin nzSimple nzSize="large"></nz-spin>
        <div class="label" *ngIf="message">{{ message }}</div>
      </div>
    </div>
  `,
    styles: [`
    .global-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,.35);
      display: grid;
      place-items: center;
      z-index: 2000; /* выше модалок/дроуэров по умолчанию */
      pointer-events: all;
    }
    .panel {
      display: grid;
      gap: .75rem;
      align-items: center;
      justify-items: center;
      padding: 1rem;
    }
    .label { color: #fff; font-size: 14px; opacity: .9; }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GlobalLoadingComponent {
  @Input() message?: string;
  loading = toSignal(this.loadingService.loading$, { initialValue: false });

  constructor(private loadingService: LoadingService) {}
}
